import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CatGoalEmployeeJobFisofoService {

  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatGoalEmployeeJobFisofo/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatGoalEmployeeJobFisofo/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getEmployeeJobs=()=> {
    return this.http.get(`${this.url}/CatGoalEmployeeJobFisofo/ListEmployeeJobs`)
      .pipe(
        map((resp:any)=> resp) //.filter(job=> job.activeId)
      );
  }
  save=(job:CatEmployeeJobModel)=> {
    return this.http.post(`${this.url}/CatGoalEmployeeJobFisofo/SaveUpdate`, job)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(job:CatEmployeeJobModel)=> {
    return this.http.post(`${this.url}/CatGoalEmployeeJobFisofo/SaveUpdate/${job.employeeJobId}`, job)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
